<template>
  <NominateForm
    ref="NominateForm"
    class="content"
    :invalid="isSubmitting"
    @submit="submit"
  />
</template>

<script>
import NominateForm from '@/components/NominateForm'
import { createNomination } from '@/services/HttpSvc'
import { USER_NOMINATIONS, USER_NOMINATION_EDIT } from '@/core/constants'

export default {
  name: 'EditNomination',

  components: {
    NominateForm,
  },

  data() {
    return {
      isSubmitting: false,
    }
  },

  methods: {
    async submit(formData) {
      this.isSubmitting = true
      try {
        const nominationId = await createNomination(formData)
        //console.log("submit"+nominationId)
        const uploadFilesResp = await this.$refs.NominateForm.uploadFiles(nominationId)

        if (uploadFilesResp.failed.length >= 1) {
          //console.error('File upload failed! uploadFilesResp: ', uploadFilesResp)
          window.location = `${USER_NOMINATION_EDIT(nominationId)}?fileUploadFailed=${uploadFilesResp.failed.length}`
        } else {
          //console.debug('File upload success! uploadFilesResp: ', uploadFilesResp)
          window.location = `${USER_NOMINATIONS}?fileUploadSuccessful=${uploadFilesResp.successful.length}`
        }
      } catch(err) {
        //console.error('nomination failed', err)
        this.isSubmitting = false
      }
    },
  },
}
</script>
